//src/api/index.js (or wherever your SummaryApi is defined)
//export const backendDomain = "http://192.168.1.162/oakya_official";
export const backendDomain = "https://oakyaitservices.com/api";


const SummaryApi = {
  SendMail: { 
    url: `${backendDomain}/mail/sendmail.php`, 
    method: "POST" 
  },
  getActiveBlog: { 
    url: `${backendDomain}/blog/blog_retrieve.php`, 
    method: "GET" 
  },
  getAllBlogs: { 
    url: `${backendDomain}/blog/blog_retrieve.php`, 
    method: "GET" },
  createBlog: { 
    url: `${backendDomain}/blog/blog_create.php`, 
    method: "POST" },
  updateBlog: { 
    url: `${backendDomain}/blog/blog_update.php`, 
    method: "POST" },
  BlogImage: {
    url: `${backendDomain}/blog` // This is the base path for your images
  },
  createCareer: { 
    url: `${backendDomain}/career/career_create.php`,
    method: "POST" 
  },
  getCareers: { 
  url: `${backendDomain}/career/career_retrieve.php`, 
  method: "GET" 
},

  createApplicant: {
        url: `${backendDomain}/job_applicant/job_applicant_create.php`,
        method: "POST"
    },
    getApplicants: {
        url: `${backendDomain}/job_applicant/job_applicant_retrieve.php`,
        method: "GET"
    },
    ResumeBasePath: {
    url: `${backendDomain}/job_applicant`
   },

trackBlogVisit: {
url: `${backendDomain}/blog_visitor/blog_visitor_create.php`,
method: "POST"
},
getVisitReport: {
url: `${backendDomain}/blog_visitor/blog_visitor_retrieve.php`,
method: "GET"
},







dashboardcounts: {
url: `${backendDomain}/dashboard/counts.php`,
method: "GET"
},



recentapplicants: {
url: `${backendDomain}/job_applicant/today_job_applicants.php`,
method: "GET"
},




adminLogin: {
  url: `${backendDomain}/admin/admin_login.php`,
  method: "POST"
}




};

export default SummaryApi;